const querystring = require('querystring');
export default class Loc {
  install(Vue) {
    Vue.prototype.$context = parseUrl();

    function parseUrl() {
      const path = window.location.pathname;
      const search = window.location.search;
      const queryString = querystring.parse(search.substr(1));

      return {
        path,
        fullPath: path + search,
        query: queryString,
      };
    }
  }
}